import request from "./curl";
import cache from "./cache_ls";
import sendmsg from "../components/sendmsg";
import chatgrp_details from "../components/chatgrp_details";
import media_utility from "./media_utility";
import utility from "./utility";
import message_format from "../components/message_format";
import pinned_message_list from "../components/pinned_message_list";
import compChatmsgMenuActions from "../components/chatmsg_menu_actions";
import content_forward_dialog  from "../components/content_forward_dialog";
import report_issue_dialog  from "../components/report_issue_dialog";
import _  from "lodash";
import InfiniteLoading from 'vue-infinite-loading';
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 300, interval: 0})
var isScrolling;

export default {
  name: 'chatmsg',
  components:{
    sendmsg,
    chatgrp_details,
    message_format,
    pinned_message_list,
    content_forward_dialog,
    InfiniteLoading,
    report_issue_dialog,
    compChatmsgMenuActions
  },
  props:["gNewMessageFromFirebaseListener", "calledFromTag", "homeRelevant", "searchKeyword", "calledFromSearch"],
  data () {
    return {
      socket:this.$store.getters.getSocket,
      loading: true,
      first_time_loader:false,
      title:'chatmsg',
      data:[],
      data_add_msg:{},
      styleObject:{
        background: '#FAFAFA',
        position: 'fixed',
        bottom: '0px',
        padding: '2px!important',
        width:'100%',
        display: 'block',
      },
      chatContainerStyleObj:{},
      chat_container_width:null,
      reply_msg:{},
      group_details_dialog:false,
      dialog:true,
      grp:{},
      showChatMsgActionMenu: false,
      do_not_scroll: false,
      selectedChatMsgForAction: '',
      show_scroll_to_reply:false,
      to_scroll_reply_msg:null,
      err_msg: '',
      snackbar: false,
      text_to_copy: '',
      selected_msg:{},
      participant_is_admin:false,
      pinned_messages:[],
      pinned_message_show:false,
      forwardDialogShow:false,
      content_forward_data:{},
      msg_search: '',
      show_search_bar: false,
      search_loader: false,
      page:1,
      per_page:process.env.VUE_APP_APP_MESSAGE_PER_PAGE,
      no_records:false,
      pagination_message_id:null,
      reply_message_data:[],
      scroll_first_time_on:false,
      infiniteId: +new Date(),
      relevantMessageId: null,
      delete_chatmsg_dialog:false,
      reportIssueDialogShow:false,
      search_msg: false,
      mention_message_show:false,
      scrollStart:false,
      selectedGroupId:"",
      user_contact_list_lf:{},
      top_to_bottom_arrow:false,
      top_to_bottom_arrow_style:{
        height: '40px',
        width: '40px',
        bottom:'100px',
        'background-color':'#e5252c',
        right:'10px'
      },
      scroll_to_top_with_set_time_out_obj: null,
      onShareFileLoader: false,
      atCommandHelp:"Usage:\r\n\r\n- Use # for adding Tags to words (no space between # and text)\r\n\r\n- Use @ for Mentioning a user\r\n\r\n- Use * for Commands\r\n\r\n- Use *boards to post message to a particular Board\r\n\r\n- Use *todo to add messages to ToDo default Board\r\n\r\n- Use *calendar with text to set events in calendar e.g. *calendar Lets catch up over a call tomorrow at 5pm\r\n\r\n- Use *reminder with text to set a reminder in calendar e.g. *reminder Status Call at 3pm on 23 Feb 2021\r\n\r\n(This Message is not visible on the group & will disappear on Refresh)",
      onboardingMsgObj: {
        // "ONBOARD_MSG_GREETINGS": "Hello!, I'm gideX, your personal career counselor", //Comes from Chat Message Table
        "ONBOARD_MSG_ASK_EMAIL": "But before I begin, I'll need your email address!",
        "ONBOARD_MSG_REASK_EMAIL": "It looks like the email you entered is invalid. Please enter a valid email address!",
        "ONBOARD_MSG_ONBOARDING_INPROGRESS": "Thanks! hangon and give me a moment to configure the gide for your queries.",
        "ONBOARD_MSG_USERFOUND_ASK_LOGIN_ON_GIDE": `Hey! I found you on GIDE.AI Platform. Please login on GIDE.AI ${process.env.VUE_APP_GIDE_DOMAIN} and let's continue the conversation in a secured environment.`,
        "ONBOARD_MSG_SOMETHING_WENT_WRONG": "Some unexpected error occurred while creating your session, kindly contact support@gide.ai",
        "ONBOARD_MSG_USER_ONBOARDING_SUCCESS": "Thanks for your email. While we continue our conversation here, do check your mailbox and verify your email via the otp. Dont forget to check your spam 🙂\n\nPlease keep chatting here."
      },
      VUE_APP_DUMMY_USER_ID_GIDEX_GROUP_ID: process.env.VUE_APP_DUMMY_USER_ID_GIDEX_GROUP_ID,
      voices: []
    }
  },
  updated() {
    this.set_msg_height();
    /*
    * This code will be remove after scrolling issue test
    */
    if(this.data.length > 0 && !this.do_not_scroll) {
      if (this.scroll_first_time_on) {
       /* 
        * If any message goes below the send box, then this code will scrollup that msg, 
        * and ensure the last message show above the send box.
        * Wait for some time befores. This allows the dom to settle its postion and then align
        */
        this.scroll_to_top_with_set_time_out();
        this.getScrollToPinnedmsg;
      }
    }

    //Get message mysql id for pagination to load older message after scrolling and adding message
    if(this.data.length > 0){
      this.pagination_message_id = this.data[0].id;
    }
  },
  created() {
    //window.addEventListener('scroll', this.onscroll);
  },
  async mounted() { 
    this.voices = speechSynthesis.getVoices()

    /*
    for (let i in this.voices) {
      console.log(i, "XXXXXVVVV000 voices", this.voices[i])
      if (this.voices[i].lang.includes("en-IN") || this.voices[i].lang.includes("hi-IN")) {
        console.log(i, "XXXXXVVVV000 voices", this.voices[i])
      }
    }
    */

   /* 
    * If any message goes below the send box, then this code will scrollup that msg, 
    * and ensure the last message show above the send box.
    * Wait for some time befores. This allows the dom to settle its postion and then align.
    * its only for Iphone because iphon taking long time to set align and its only for component load.
    */
    if(window.webkit){
      window.setTimeout(()=>{
        this.scroll_to_top();
      }, 1500)
    }
   
   // Listen for scroll events
   window.addEventListener('scroll',  ()=> {
    this.scrollStart = true;
    // Clear our timeout throughout the scroll
    window.clearTimeout( isScrolling );

    if(window.webkit){
      window.setTimeout(()=>{
          //top to bottom scroll button
          if(!this.scroll_first_time_on){
            this.onScroll();
          }
      }, 1500)
    }
    else{
       //top to bottom scroll button
      if(!this.scroll_first_time_on){
        this.onScroll();
      }
    }
   
    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(()=> {
      // Run the callback
      this.scrollStart = false;
    }, 66);
   }, false);
     
    this.get_group_details();

    this.chatContainerStyleObj = {
      'height': `${this.getClientDeviceHeight - 160}px`,
      'background-color':'#fafafa'
    };
    
    if(this.selectedTag){
      //Mentioned
      if(this.selectedTag.type == 4){
        this.mention_message_show = true;
      }
    }

    this.user_contact_list_lf = await this.getUserContactList;

    let sharedContentObj = this.externalAppSharedText;
    if (sharedContentObj) { 
      let self = this;
      self.onShareFileLoader = true;

      //Set a timeout so that loader is visible momentarily. If not then the async await the loader from displaying
      setTimeout(async function(){
        var sharedContentObjResp = await media_utility.externalContentBuilder(this, sharedContentObj);
        
        if(sharedContentObjResp == false || sharedContentObjResp.length <= 0){
          self.snackbar = true;
        }
        else{
          for(let sharedObj of sharedContentObjResp){
            self.msg = {};
            self.msg.msg = sharedObj.msg;      
            self.chatmsg_add(self.msg, null, sharedObj.file);  
          }
  
          self.$store.commit("setExternalAppSharedText", null);  
          self.onShareFileLoader = false;
        }
      }, 300);
    }

    if (this.userData.user_id == process.env.VUE_APP_DUMMY_USER_ID_TO_ONBOARD_USER_TO_MESH) {
      this.startOnboardingUserToGideX()
      return
    }
  },
  beforeDestroy() {
    this.$store.commit('setScrollToPinnedmsg', null);
    this.scroll_first_time_on = false;
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      this.selectedGroupId = await this.$store.getters.selectedGroup;
      let getUnreadChatgrp = await this.getUnreadChatgrp;
      if(getUnreadChatgrp && Object.keys(getUnreadChatgrp).length > 0){
        this.$delete(getUnreadChatgrp, this.selectedGroupId);
      }

      await this.$store.commit('setUnreadChatgrp', getUnreadChatgrp);
      return this.selectedGroupId;
    },
    selectedTag() {
      return this.$store.getters.getSelectedTag;
    },
    externalAppSharedText() {
      return this.$store.getters.externalAppSharedText;
    },
    selectedDeeplinkMessage() {
      return this.$store.getters.selectedDeeplinkMessage;
    },
    relevantMessage() {
      return this.$store.getters.relevantMessage;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
    async getUnreadChatgrp(){
      return await this.$store.getters.getUnreadChatgrp;
    },
    getSnackBar(){
      return this.$store.getters.getSnackBar;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    },
    getListenerChatmsgAddResponse(){
      return this.$store.getters.getListenerChatmsgAddResponse;
    },
    getListenerChatgrpEditResponse(){
      return this.$store.getters.getListenerChatgrpEditResponse;
    },
    getListenerGroupDeleteResponse(){
      return this.$store.getters.getListenerGroupDeleteResponse;
    },
    getListenerUserEditResponse(){
      return this.$store.getters.getListenerUserEditResponse;
    },
    getListenerGroupActionResponse(){
      return this.$store.getters.getListenerGroupActionResponse;
    },
    getListenerChatmsgDeleteResponse(){
      return this.$store.getters.getListenerChatmsgDeleteResponse;
    },
    filteredMessages() {
      let keys = Object.keys(this.data);
      if(this.msg_search){
        this.search_loader = true;
        keys.filter(key => {
          let msg = this.data[key]['text_msg'];
          return msg.toLowerCase().indexOf(this.msg_search.toLowerCase())>=0;
        });
      }

      let filtered = _.orderBy(this.data, 'message_time');
      this.search_loader = false;
      return filtered;
    },
    getScrollToPinnedmsg(){
      if(this.$store.getters.getScrollToPinnedmsg != null){
        this.scroll_to_msg(this.$store.getters.getScrollToPinnedmsg, true, this.$store.getters.getScrollToPinnedmsg.this_message_id);
      }
    },
    async getUserContactList(){
      return await this.$store.getters.getUserContactList;
    },
    async getFrameName() {
      return await this.$store.getters.getFrame;
    }
  },
  methods: {
    /**
     * onScroll
     */  
    onScroll(){
      //var ele = this.$refs.chat_container;
      let scrollHeight = document.documentElement.scrollHeight;

      //if(process.env.VUE_APP_DEBUG == "true"){console.log(window.scrollY, this.getClientDeviceHeight,window.scrollY+this.getClientDeviceHeight, scrollHeight);}
      //Add +1 to manage the height in phone.
      if ((window.scrollY + this.getClientDeviceHeight + 1) >= scrollHeight) { 
        this.top_to_bottom_arrow = false;
      } 
      else{ 
          this.top_to_bottom_arrow = true;
      }
    },
    /**
     * top_to_bottom_scroll
     * 
     */  
    top_to_bottom_scroll(){
      this.scroll_to_top();
      this.top_to_bottom_arrow = false;
    },
    /**
     * get_group_details
     * Get from LS, else via API
     * TODO: This function can be optimised. No need for the loop use the group_id as the object key to get/set data
     */
    async get_group_details() {
      let grp_details = await this.getChatgrpList;

      if(grp_details) {
        for(let index in grp_details) {          
          if(grp_details[index]){
            //Get data for the currently selected Group
            if(grp_details[index]['group_id'] && (grp_details[index]['group_id'] === await this.selectedGroupId)) {
              this.grp = grp_details[index];
              this.participant_is_admin = (this.grp.role == 1) ? true : false;
              break;
            }
          }
        }
      }
      else{
        this.$router.push('/warnings');
      }
    },
    /**
     * add_new_msg
     * Called immediately during send, if message has media. 
     * Then again called during recv on listener.
     * On listen if the sent message has a media, then media id needs to be update for the sender
     * 
     */      
    async add_new_msg(msg) {
      let msg_key = Object.keys(msg);
      if (!msg[msg_key].is_system_msg && this.userData.user_id == process.env.VUE_APP_DUMMY_USER_ID_TO_ONBOARD_USER_TO_MESH) {
        let userEmail = Object.values(msg)[0].text_msg
        let emailRegExp = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
        if (emailRegExp.test(userEmail)) {
          // removing \n
          userEmail = userEmail.replace(/\n/g, "").trim()
          setTimeout(async () => {
            this.addOnboardingMsgToUI("ONBOARD_MSG_ONBOARDING_INPROGRESS")

            // wait for some time so that the user should be able to view the message that we are creating a session for him
            await new Promise((resolve) => {
              setTimeout(() => {
                resolve()
              }, 3000)
            })

            this.gidexOnboarduser(userEmail)
          }, 1500)
        }
        else {
          setTimeout(() => {
            this.addOnboardingMsgToUI("ONBOARD_MSG_REASK_EMAIL")
          }, 600)
        }
      }

      //If Selected Chatgrp is same as the message received grp then add the message to the current chat window and scroll up
      if(await this.selectedGroup === msg[msg_key].group_id){
        //check message is alredy in this.data or not if not then pushed in this.data
        let msg_index_from_list = this.data.findIndex((message) => { return message.this_message_id == msg[msg_key].this_message_id});
        
        //If message not found in this.data, push and scroll
        if(msg_index_from_list == "-1"){
          //Called during sending message
          this.data.push(msg[msg_key]);
          
          //On adding a new msg, scroll so that the lastest message is shown above send box
          if(!this.top_to_bottom_arrow){
            this.$nextTick(() => {
              this.scroll_to_top();
            });
          }
        }
        else{
          //Called during receiving on listener message. Update the Auto incremented Message Id
          this.data[msg_index_from_list].id = msg[msg_key].id;
          this.$set(this.data, msg_index_from_list, this.data[msg_index_from_list]);
        }
        
        if(msg[msg_key].sender_id != await this.userData.user_id) {
          this.speak(msg[msg_key].text_msg)  
        }
                
        if(!this.top_to_bottom_arrow){
          this.scroll_to_top_with_set_time_out();
        }

        this.top_to_bottom_arrow_style['background-color'] = '#ffca28'; //orange color
      }
    },
    /**
     * get_chat_messages_from_api
     * //async call to get all message from server for scrolling
     */
    async get_chat_messages_from_api($state){
      let selectedGroupId = await this.selectedGroup;
      //show loader in middle of page when message not found in cache list its uses first time only
      if(this.pagination_message_id == null){
        this.first_time_loader = true;
        this.loading = false;
      }
      else{
        //its used for showing loader using paging scroll
        this.loading = true;
      }
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", selectedGroupId);

      /* pagination_type = page_index is get message list with having last message detail or index
       *  pagination_type = per_page when get message list for per page and page in stand format.
       * if page_index then message_time is required otherwise page is required
       */
      post_data.append("pagination_type", 'page_index');
      if(this.pagination_message_id){
        post_data.append('message_id', this.pagination_message_id);
      }

      //To limit how much message you want to load at every request
      post_data.append("per_page", this.per_page);

      //For chat tag messages
      if(this.selectedTag) {
        post_data.append("tag_type", this.selectedTag.type);
        post_data.append("tag_name", this.selectedTag.name);
        post_data.append("user_id", this.userData.user_id);

        if(this.homeRelevant) {
          post_data.append("all_relevant", true);
        }
      }

      //For msg search
      if(this.calledFromSearch && this.searchKeyword) {
        post_data.append("search_keyword", this.searchKeyword);
      }

      request.curl(this, "message_list", post_data)
      .then(async response => {
        this.loading = false;
        if(response.resp_status) {
          //Save in local storage it also call only first time if data not found in localforage
          if(this.pagination_message_id == null){
            //Do not set tag search results to local forage as they could be less than the original msg count
            //and this causes loading issues
            if(!this.selectedTag && !this.calledFromSearch) {
              await cache.set_chatmsg_list_lf(selectedGroupId, response.resp_data.data);
            }
            else{
              //this is first for relavant or search
              this.data = await response.resp_data.data.reverse();
              this.scroll_to_top_with_set_time_out();
            }
            this.first_time_loader = false;
            this.loading = false;
          }
          else{
            //Called on scrolling up
            //if chat message list not found from localforage then load from server
            //Use ... to merge response data into display data
            await this.data.unshift(...response.resp_data.data.reverse());
          }

          this.reply_message_data.push(...response.resp_data.reply_message_data);
          this.set_message_data();

          //Add messages in cache list when message not found in cache or first time          

          $state.loaded();
          // This is needed if pagination_type = per_page
          if(this.data.length == response.resp_data.total_count){
            $state.complete();            
          }
        }
        else{
          this.first_time_loader = false;
          $state.complete();
        }
        this.search_msg = false;
      });
    },
    /**
     * get_chat_messages_from_api_for_localforage
     * Backend to localforage SYNC API
     * Called only when that group is selected. Either after logout/login OR when I switch groups. It is not called on scroll
     *
     * Get latest message from server always and update cahche list. there are also not need loader
     */
    async get_chat_messages_from_api_for_localforage(){
      let selectedGroupId = await this.selectedGroup;
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", selectedGroupId);
      post_data.append("pagination_type", 'page_index');
      post_data.append('message_time', null);
      post_data.append("per_page", this.per_page);

      request.curl(this, "message_list", post_data)
      .then(async response => {
        if(response.resp_status) {
          await cache.set_chatmsg_list_lf(selectedGroupId, response.resp_data.data);
          let msg_data = await response.resp_data.data.reverse();
          
          if(msg_data.length >= this.per_page){
            //Empty the msg list, 
            this.data = [];
          }
          
          msg_data.forEach((msg)=>{
            let msg_index = this.data.findIndex((m)=> { return m.this_message_id == msg.this_message_id});
            if(msg_index == '-1'){ 
              //Push one by one of not found in this.data, so that ht of message is managed during rendering
              this.data.push(msg);
            }
          });
          
          this.reply_message_data = response.resp_data.reply_message_data;
          this.set_message_data();
          this.$nextTick(()=>{
            this.scroll_to_top();
          }) 
        }
      });
    },
    /**
     * get_chat_all_messages_from_api
     * Get the Messages for the selected Group for reply message and pinned message scrolling
     * There are not need loader and and cache update
     */
    async get_chat_all_messages_from_api(){
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", await this.selectedGroup);
      post_data.append("pagination_type", 'page_index');
      
      if(this.pagination_message_id){
        post_data.append('message_id', this.pagination_message_id);
      }
      
      if(this.current_message_id){
        post_data.append('current_message_id', this.current_message_id);
      }
      
      post_data.append("per_page", 'all');
      await request.curl(this, "message_list", post_data)
      .then(async response => {
        if(response.resp_status) {
          await this.data.unshift(...response.resp_data.data.reverse());
          this.reply_message_data.push(...response.resp_data.reply_message_data);
          this.set_message_data();
        }
      });
    },
    /**
     * get_chat_messages
     * Get the Messages for the selected Group
     */
    async get_chat_messages($state) {
      let selectedGroup = await this.selectedGroup;
      
      if(this.calledFromTag || this.calledFromSearch) {
        if(this.calledFromSearch) {
          if(this.searchKeyword && this.searchKeyword != '') {
            this.get_chat_messages_from_api($state);
          }
          else{
            this.loading = false;
            this.search_msg = 'Please type a keyword and hit enter.';
          }
        }
        else{
          this.get_chat_messages_from_api($state);
        }
      }
      else{
        //get all message from localforage indexDB
        cache.get_chatmsg_list_lf(selectedGroup)
        .then(async (chatmsg_list)=>{
          //If load first time and no have messages in loacalforage otherewise call api
          if(this.pagination_message_id == null && chatmsg_list && chatmsg_list.length > 0){
          
            this.data.unshift(... await chatmsg_list.reverse());
            this.get_chat_messages_from_api_for_localforage();
            
            //Show the blink, after loading the infinity loader
            this.set_message_data();

            if($state) {
              if(this.data.length >= this.per_page){
                $state.loaded();
              }
              else{
                $state.loaded();
                $state.complete();
              }
            } 
            this.scroll_first_time_on = true;
          }
          else{
            this.scroll_first_time_on = false;
            if(selectedGroup){
              this.get_chat_messages_from_api($state);
            }
          }
        });
      }
    },
    /**
     * get_taged_msg_list
     */
    async get_taged_msg_list() {
      this.loading = true;
      var post_data = new FormData();
      post_data.append("user_id", this.userData.user_id);
      post_data.append("tag_type", this.selectedTag.type);
      post_data.append("group_id", await this.selectedGroup);
      post_data.append("tag_name", this.selectedTag.name);

      request.curl(this, "chat_tag_msg_list", post_data)
        .then(response => {
          if(response.resp_status){
            this.data.unshift(...response.resp_data);
            this.scroll_first_time_on = true;
            this.loading = false;

          }else{
            this.loading = false;
          }
        });
    },
    /**
     * set_message_data
     * Set other message funcationality here like pinned message, selectedDeeplinkMessage and others if any
     */
    set_message_data(){
      this.$store.commit('setPinnedMessage', this.pinned_messages);

      //If Message opened via Deeplink then open that message directly
      if(this.selectedDeeplinkMessage){
        if (process.env.VUE_APP_DEBUG == "true") {console.log("set_message_data on DEEPLINK =>", JSON.stringify(this.selectedDeeplinkMessage));}

        this.scroll_to_msg(this.selectedDeeplinkMessage.this_message_id, true, this.selectedDeeplinkMessage); //Reuse the method to scroll to the message

        setTimeout(() => {
          //This is a hack. Because of infinity loader, reloading the messages, the blink was not working on IOS. 
          //So set the data for deeplink to null after 5s. It is expected that within this time the blink would have worked 
          //and user would have seen the message
          this.$store.commit('setSelectedDeeplinkMessage', null);
        }, 5000);
      }
    },
    /**
     * set_msg_height
     */
    set_msg_height() {
      this.chat_container_width = this.$refs.chat_container.clientWidth;
    },
    /**
     * scroll_to_top
     */
    scroll_to_top(replied = false) {
      let container = this.$el;
      let options = {
        duration: 0,
        offset: 0,
      };
      if(replied){
        this.$vuetify.goTo(container.scrollHeight,options);
      }
      else{
        if(this.relevantMessage && this.relevantMessage !== "null" && !this.do_not_scroll){
          this.relevantMessageId = this.relevantMessage.this_message_id;
          this.scroll_to_msg(this.relevantMessage, false, this.relevantMessage.this_message_id);
          this.$store.commit("setRelevantMessage", null);
          this.do_not_scroll = true;
        }
        else{
          //pinned message not scrolled
          if(this.pinned_message_show){
            this.$vuetify.goTo(0, options);
          }
          else{
            if(container.scrollHeight > this.getClientDeviceHeight && !this.do_not_scroll){
              this.$vuetify.goTo(container.scrollHeight,options);
            }
          }
        }
      }
    },
    /**
     * chatmsg_add
     */
    async chatmsg_add(msg, mention_users, collect_attachment_file) {
      if(Object.keys(this.grp).length <= 0){
        this.err_msg =  "You are not a member of this group anymore";
        this.snackbar = true;
        return;
      }
      
      let send_data = {};
      let selectedGroupId = await this.selectedGroup;      
      let this_message_id = utility.getUniqueId(this.userData.user_id, selectedGroupId);

      let post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", selectedGroupId);
      post_data.append('this_message_id', this_message_id);

      //Mention user create tag in backend
      if(mention_users && mention_users.length > 0){
        post_data.append('mention_users', JSON.stringify(mention_users));
      }
      let d = new Date();


      send_data['sender_id'] = this.userData.user_id;
      send_data['this_message_id'] = this_message_id;
      send_data['sender_name'] = this.userData.user_name;
      send_data['group_id'] = selectedGroupId;
      send_data['sender_image'] = this.userData.image;
      send_data['message_time'] = d.getTime();

      let msg_created = false;

      //If a tag (Channel, relevant or city) is open than also add the msg to that tag
      if(this.selectedTag) {
        post_data.append("tag_type", this.selectedTag.type);
        post_data.append("tag_name", this.selectedTag.name);

        //If chat_tag is relevant than add #tag in the end of that msg
        if(this.selectedTag.type === 2 || this.selectedTag.type === 3) {
          post_data.append('text_msg', msg.msg+" "+this.selectedTag.name);
          send_data['text_msg'] = msg.msg+" "+this.selectedTag.name;
          msg_created = true;
        }
      }

      //Add Board & Topic Id List to the message data      
      if(msg.at_board_topic_list && msg.at_board_topic_list.length > 0){
        post_data.append('at_board_topic_list', JSON.stringify(msg.at_board_topic_list));        
      }

      if(!msg_created) {
        post_data.append('text_msg', msg.msg);
        send_data['text_msg'] = msg.msg;
      }

      //@todo
      if(msg.is_reply) {
        post_data.append('is_reply', true);
        post_data.append('message_id', msg.message_id);

        send_data['is_reply'] = true;
        send_data['message_id'] = msg.message_id;
        
        //if reply message then push the parent message object in reply_message_data
        if(this.reply_msg && Object.keys(this.reply_msg).length > 0){
          this.reply_message_data.push(this.reply_msg);
        }
        this.replyClosed(true);
      }
      else{
        send_data['is_reply'] = false;
        send_data['message_id'] = '';
      }

      send_data['sender_location'] = '';
      send_data['sender_designation'] = '';
      send_data['sender_fcm_push_token'] = '';
      send_data['message_content_type'] = '';
      let new_msg ={};

      if(collect_attachment_file && (collect_attachment_file instanceof File) == true){
        let media_file = {
          mod_obj_id:this_message_id,
          module_type:'message',
          group_id:selectedGroupId,
          user_id:this.userData.user_id,
          file_name:collect_attachment_file.name,
          file_mime_type:collect_attachment_file.type,
          file_type:media_utility.getFileType(collect_attachment_file.type),
          file_ext:media_utility.checkFileExtension(collect_attachment_file.name),
          file_size:collect_attachment_file.size,
          deleted:0,
          created_on:utility.moment().format('YYYYMMDD')
        };

        post_data.append("file", collect_attachment_file);
        post_data.append('message_content_type', 1);
        send_data['message_content_type'] = 1;
        send_data['message_content_data'] = media_file;
      }

      let post_the_message_to_server = true;
      if(send_data['text_msg'].indexOf("*help") != -1){
        send_data['text_msg'] = this.atCommandHelp;
        post_the_message_to_server = false;
      }

      //On Send Display the Message immediately. When received on listener the same mesage gets updated in cache and this.data
      this.$set(new_msg, this_message_id, send_data);
      this.top_to_bottom_arrow = false;
      this.add_new_msg(new_msg);

      if (this.userData.user_id == process.env.VUE_APP_DUMMY_USER_ID_TO_ONBOARD_USER_TO_MESH) {
        // Do not save the messages into database when the user is getting onboarded
        return
      }

      if(post_the_message_to_server == false){
        return;
      }

      request.curl(this, "message_add", post_data)
      .then(response => {
        if(response.resp_status){
          this.data_add_msg = response.resp_data;
        }
        else{
          this.err_msg =  response.resp_msg;
          this.snackbar = true;
        }
      });
    },
    /**
     * msg_time
     */
    msg_time(timestamp) {
      return utility.get_message_datetime(timestamp, 'DD/MM/YYYY');
    },
    /**
     * format_msg
     */
    format_msg(msg) {
      //Replace line break with BR for HTML rendering
      if(msg){
        msg = msg.replace(/(\r\n|\n)/g, "<br/>");
      }
      return msg;
    },
    /**
     * report_msg
     */
    reply() {
      this.reply_msg = this.selectedChatMsgForAction;
      this.showChatMsgActionMenu = false;
    },
    /**
     * replyClosed
     * Called from sendmsg component after reply is closed
     */
    replyClosed(closed){
      this.reply_msg = {};
      if(closed) {
        this.do_not_scroll = false;
      }
      else{
        this.do_not_scroll = true;
      }
    },
    /**
     * fetch_sender_details
     * sender details from messages data
     * @todo: only name is fetched but designation and company can also be concatenated(Discussion Pending)
     */
    fetch_sender_details(msg_id) {
      let message = this.data.find(m => m.this_message_id == msg_id);
      if(message != null && message != undefined ){
        return message.sender_name;
      }
      else{
        message = this.reply_message_data.find(m => m.this_message_id == msg_id);
        return message.sender_name;
      }
    },
    /**
     * scroll_to_msg
     * This call from when click event and call from many function where we want message scrolling
     */
    async scroll_to_msg(msg_id, blink = true, pinned_scrolled=null) {
      //if call from pinned message then get message id and assing in to_scroll_reply_msg
      if(pinned_scrolled){
        msg_id = pinned_scrolled.this_message_id;
      }

      //This function is used for wait until all data renderer at UI
      this.$nextTick(async()=>{
        //this condition is use for check any message id
        if(msg_id) {
          /*Check message id is present in this.data for get message and scrolled from this.data
          * and if not found then go for server and load message between message id and latest message id that we have from
          * localofrage and after getting scrolling
          */
          let isPresent = this.data.some((m)=>{
            return m.this_message_id === this.to_scroll_reply_msg
          });

          //scrolled if message found in this.data
          if(isPresent){
            this.scroll_to_msg_api(msg_id, blink);
          }
          else{
            //if call from pinned message
            if(pinned_scrolled){
              this.current_message_id = pinned_scrolled.id;
            }
            else{
              //Call from reply message scroll
              let index = this.reply_message_data.findIndex(x => x && x.this_message_id && x.this_message_id === msg_id);
              let reply_message_data = this.reply_message_data[index];
              this.current_message_id = reply_message_data.id;
              //console.log(this.current_message_id);
            }

            await this.get_chat_all_messages_from_api();
            this.scroll_to_msg_api(msg_id, blink);
          }
        }
      })
    },
    /**
     * scroll_to_msg_api
     */
    scroll_to_msg_api(msg_id, blink=true){
      let options = {
        offset: (this.getClientDeviceHeight/3), //Scroll to 3 Msg before, so that the selected message is displayed in the middle of the screen
      }
      console.log("scroll_to_msg_api DEEP =>",msg_id.toString());

      //this.$vuetify.goTo('.'+this.to_scroll_reply_msg.toString(), options); OLD
      let el = this.$el.getElementsByClassName(msg_id.toString())[0];
      this.$vuetify.goTo(el, options);
      this.showChatMsgActionMenu = false;
      if(blink){
        this.blink_msg(msg_id);
      }
    },
    /**
     * blink_msg
     * Blink msg for 3 second
     */
    blink_msg(msg_id) {
      let el = this.$el.getElementsByClassName('item_'+msg_id)[0];
      el.classList.add("blink-color");
      setTimeout(() => {
        el.classList.remove("blink-color");        
      }, 3000);
    },
    /**
     * chatmsg_actions_menu_show
     */
    chatmsg_actions_menu_show(msg) {
      if(!this.isElementVisible){
        return
      }

      if(this.scrollStart == true){
        return;
      }

      if(this.selectedTag){ 
        if(this.selectedTag.type == 4){
          //For Mention
          this.showChatMsgActionMenu = false;
          return;
        }
      }
      
      this.do_not_scroll = true;
      this.selectedChatMsgForAction = msg;
      this.text_to_copy = msg.text_msg;
      
      if(this.selectedChatMsgForAction.is_reply == 1){
        this.show_scroll_to_reply = true;
        this.to_scroll_reply_msg = this.selectedChatMsgForAction.message_id;
      }
      else{
        this.show_scroll_to_reply = false;
        this.to_scroll_reply_msg = '';
      }

      if(this.selectedChatMsgForAction.message_type == undefined){
        this.selectedChatMsgForAction.message_type = '10';
      }

      this.selectedChatMsgForAction.userData = this.userData;
      this.selectedChatMsgForAction.participant_is_admin = this.participant_is_admin;

      //Set the Menu Show/Hide Options
      this.selectedChatMsgForAction.showChatMsgActionMenu = true;
      this.selectedChatMsgForAction.showDoReply = true;      
      this.selectedChatMsgForAction.showDeleteMessage = true;
      this.selectedChatMsgForAction.showPinnedMessage = true;
      this.selectedChatMsgForAction.showUnPinnedMessage = true;
      this.selectedChatMsgForAction.showGotoMessage = true;
      this.selectedChatMsgForAction.showForwardMessage = true;
      this.selectedChatMsgForAction.showCopyMessage = true;
      this.selectedChatMsgForAction.showReportIssue = true;
      this.showChatMsgActionMenu = true;
      //this.reply_msg = {};
    },
    /**
     * doCopy
     * Copy msg from "copy-msg-input" text field
     */
    doCopy: function () {
      var copyText = document.getElementById("copy-msg-input");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.showChatMsgActionMenu = false;
      this.snackbar = true;
      this.err_msg = 'Copied';
    },
    /**
     * open_delete_chatmsg_dialog
     *
     */  
    open_delete_chatmsg_dialog(){
      this.showChatMsgActionMenu = false;
      this.delete_chatmsg_dialog = true;
    },
    /**
     * delete_message
     *
     */
    delete_message:async function(){
      let this_message_id = this.selectedChatMsgForAction.this_message_id;
      let message_index = this.data.findIndex((msg) => msg.this_message_id === this_message_id);
      this.$delete(this.data, message_index);

      this.snackbar = true;
      this.err_msg = 'Message deleted';
      //async message delete
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", await this.selectedGroup);
      post_data.append("this_message_id", this_message_id);

      request.curl(this, "message_delete", post_data)
        .then(response => {
          if(response.resp_status) {
            console.log(response);
          }
        });
      this.delete_chatmsg_dialog = false;
    },
    /**
     * set_participant_as_admin
     * Get group admin
     * TODO:- Change the name of this function to set_participant_as_admin
     */
    set_participant_as_admin(){
        this.$nextTick(function(){
        //Check if Participant is Admin
        this.participant_is_admin = false;
        if(this.grp.role == 1 || this.grp.role =="1"){
          this.participant_is_admin = true;
        }
      });
    },
    /**
     * updateShowMsgActionsState
     * update the showChatMsgActionMenu value after action menu closes, so that the menu closes
     */    
    async updateShowMsgActionsState(showChatMsgActionMenu){
      this.showChatMsgActionMenu = showChatMsgActionMenu;
    },   
    /**
     * pin_msg
     */
    async pin_msg(new_message_type) {
      let selectedGroupId = await this.selectedGroup;
      let msg_id = this.selectedChatMsgForAction.this_message_id;
      let index = this.data.findIndex(x => x && x.this_message_id && x.this_message_id === msg_id);
      this.$set(this.data[index],'message_type', new_message_type);

      this.do_not_scroll = true;
      this.showChatMsgActionMenu = false;
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", selectedGroupId);
      post_data.append("this_message_id", msg_id);
      post_data.append("message_type", new_message_type);

      request.curl(this, "message_pin", post_data)
        .then(async response => {
          if(response.resp_status) {
            //Update in Chatmsg List as well
            let chatmsg_list = await cache.get_chatmsg_list_lf(selectedGroupId);
            let index = chatmsg_list.findIndex(x => x && x.this_message_id && x.this_message_id === msg_id);

            if(chatmsg_list[index]){
              chatmsg_list[index].message_type = new_message_type;
              await cache.set_chatmsg_list_lf(selectedGroupId, chatmsg_list);
            }
          }
        });
    },
    /**
     * share_send_dialog_open
     */
    async share_send_dialog_open(){
      this.showChatMsgActionMenu = false;
      this.content_forward_data.text_msg = this.text_to_copy;
      this.content_forward_data.module = 'message';
      this.content_forward_data= this.content_forward_data;
      
      //media message forward
      if(this.selectedChatMsgForAction.message_content_type == 1){ // 1 is media message
        this.content_forward_data.message_content_type = this.selectedChatMsgForAction.message_content_type;
        this.content_forward_data.message_content_id = this.selectedChatMsgForAction.message_content_data.id;
      }
      else{
        this.content_forward_data.message_content_type = null
        this.content_forward_data.message_content_id = null;
      }
      
      this.forwardDialogShow = true;
    },
    /*
    * report_issue_dialog_open
    * 
    */
    report_issue_dialog_open(){
      let msg = this.selectedChatMsgForAction;
      var report_issue_data = {};
      report_issue_data.module_obj_id = msg.this_message_id;
      report_issue_data.content_text = msg.text_msg;
      report_issue_data.module_type = 'message';

      this.report_issue_data= report_issue_data;
      this.showChatMsgActionMenu = false;
      this.reportIssueDialogShow = true;
    },
    /*
    * set_reply_message
    * 
    */
    set_reply_message(msg, data){
      if(msg.is_reply && msg.message_id != undefined && msg.message_id != null) {
        let reply_message = data.find(m => m.this_message_id == msg.message_id);
        if(reply_message == null && reply_message == undefined){
          reply_message = this.reply_message_data.find(m=>m.this_message_id == msg.message_id);
        }
        return reply_message;
      }
    },
    /**
    * getUserTags for mention user
    */
   getUserTags(message){
      var regex = new RegExp('{@userid_'+'(.*?)'+'}', 'gm');
      var tagStrArr = message.match(regex);
      return tagStrArr;
    },
   /**
    * replaceUserIdMACRO 
    * While rendering Replace User tag with user name by user id for mention user
    */
    async replaceUserIdMACRO(message, tagStrArr){
      var user_contact_list = await this.getUserContactList;

      if(user_contact_list){
        if(tagStrArr){
          tagStrArr.forEach((tag) => {
            if(tag){
              //While Rendering, replace each MACRO with their respective UserName. Remove '{' and '}' and split by '-'
              var userTag = tag.replace('{', '').replace('}','').split('_');
              var user_id = userTag[1].trim();

              var user_name = "";
              if(userTag[2]){
                user_name = userTag[2].trim();
              }
           
              //Set the HTMl Color. If user is found in the contact list then use that found user name else use the name in the MACRO. User may have quit the grou or may not be in the contact list. Then show the name in the MACRO
              if(user_contact_list[user_id]){
                user_name = '<a href="javascript:void(0)" class="user_tag_link"><span class="at_symbol">@</span>'
                +user_contact_list[user_id]['user_name'] + '</a>';
                message = message.replace(tag, user_name);
              }
              else{
                user_name = '<a href="javascript:void(0)" class="user_tag_link"><span class="at_symbol">@</span>'
                +user_name+ '</a>';
                message = message.replace(tag, user_name);
              }
            }
          });
        }
      }
    
      return message;
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /**
     * get_user_participant
     *
     */
    get_user_participant(){
      let grp = this.grp;
      let user_participant = {};
      if(grp.participants != undefined){
        //loop for get participan who participant obj key is diffrent from participant id and get user participant
        Object.keys(grp.participants).forEach(key=>{
          if(grp.participants[key].participant_id == this.userData.user_id){
            user_participant = grp.participants[key];
            return;
          }
        });
      }

      return user_participant;
    },  
    /*
    * go_to_msg
    * */
    go_to_msg(){
      this.scroll_to_msg(this.selectedChatMsgForAction.message_id);
    },
    /*
    * scroll_to_top_with_set_time_out
    * */
    scroll_to_top_with_set_time_out(){
      //Clear the previous object and then set a new one. 
      //So incase this method is called continously during a scroll, should stop jerkiness in scroll
      if(this.scroll_to_top_with_set_time_out_obj){
        clearTimeout(this.scroll_to_top_with_set_time_out_obj);
      }
      
      this.scroll_to_top_with_set_time_out_obj = window.setTimeout(()=>{
        this.scroll_to_top();
        this.scroll_first_time_on = false;
      }, 300);
    },
    /*
    * get_user_icon
    * */
    get_user_icon(msg){
      var user = {
        user_id : msg.sender_id,
        image : msg.sender_image,
        user_name: msg.sender_name
      }
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list_lf);
      return user_icon;
    },
    /**
     * start Onboarding User To GideX
     */
    startOnboardingUserToGideX () {
      try {
        // this.addOnboardingMsgToUI("ONBOARD_MSG_GREETINGS") // This comes from DB

        setTimeout(() => {
          this.addOnboardingMsgToUI("ONBOARD_MSG_ASK_EMAIL")
        }, 500)
      }
      catch (err) {
        console.error("Exception in startOnboardingUserToGideX() and err: ", err.message)
      }
    },
    /**
     * addOnboardingMsgToUI
     */
    addOnboardingMsgToUI (msgTitle) {
      try {
        const currentTs = Date.now()
        const messageObj = {
          [msgTitle]: {
            group_id: process.env.VUE_APP_DUMMY_USER_ID_GIDEX_GROUP_ID,
            is_reply: 0,
            id: currentTs,
            message_content_type: null,
            message_id: null,
            message_time: currentTs,
            message_type: "10",
            sender_id: process.env.VUE_APP_GIDE_GPT_USER_ID,
            sender_image: "https://gide-assets-prod.s3.amazonaws.com/USER/CHATGPT000001/d1686dc0-98d6-11ef-82b2-a14fdc303208.png",
            sender_name: "gideX",
            text_msg: this.onboardingMsgObj[msgTitle],
            this_message_id: currentTs,
            is_system_msg: true
          }
        }
        this.add_new_msg(messageObj)
      }
      catch (err) {
        console.error("Exception in addOnboardingMsgToUI() and err: ", err.message)
      }
    },
    /**
     * gidexOnboarduser 
     */
    async gidexOnboarduser (userEmail) {
      try {
        let post_data = new FormData();
        post_data.append("user_email", userEmail);

        request.curl(this, "gidex_onboard_user", post_data)
        .then(async response => {
          if (response.resp_status) {
            // Get the new user logged into mesh
            this.$store.dispatch("destroyLocalStore");
            let user_profile_data = {
              user_name: response.resp_data.user_name,
              user_email: response.resp_data.user_email,
              is_verified: true,
              mobile_no: response.resp_data.user_mobile,
              login_process: 'email',
              user_id: response.resp_data.user_id,
              chats: response.resp_data.chat
            };
            //Save userdata in LS
            this.$store.commit("setUserProfile", user_profile_data);

            if(response.resp_data.group_id){
              this.$store.commit("setSelectedGroup", response.resp_data.group_id);
            }

            // set the auth token of the newly created user
            this.$store.commit("setAuthToken", response.token);

            // set the chatgrp list in LS
            if (response.chatgrp_list) {
              await this.$store.commit('setChatgrpList', response.chatgrp_list);
            }

            // emit the encrypted userData to the parent app so that this can be saved in parent app's localstorage
            /*
            (DISABLED)
            let appName = await this.getFrameName
            switch(appName) {
              case "GIDE":
                window.parent.postMessage({ type: 'SET_USER_DATA', user_data: utility.gide_aes_encrypt("user_data", JSON.stringify(response.resp_data)) }, process.env.VUE_APP_GIDE_DOMAIN);
              break
              case "GideMarketingWebsite":
                window.parent.postMessage({ type: 'SET_USER_DATA', user_data: utility.gide_aes_encrypt("user_data", JSON.stringify(response.resp_data)) }, process.env.VUE_APP_MKTING_WEBSITE_URL);
            }*/

            this.addOnboardingMsgToUI("ONBOARD_MSG_USER_ONBOARDING_SUCCESS")
          }
          else {
            if (response.resp_code == "ERR_USER_EXISTS_ON_GIDE") {
              this.addOnboardingMsgToUI("ONBOARD_MSG_USERFOUND_ASK_LOGIN_ON_GIDE")
            }
            else {
              this.addOnboardingMsgToUI("ONBOARD_MSG_SOMETHING_WENT_WRONG")
            }
          }
        });
      }
      catch(err) {
        console.error("Exception in gidexOnboarduser() and err: ", err.message)
      }
    },
    /**
      * isElementVisible
      * Returns a boolean value, that determines whether a certain element is to be displayed on mesh
      * Used to hide certain elements from the UI in case, mesh is opened in an iframe on GIDE Maketing website
      */
    isElementVisible() {
      const frame = cache.get_frame()
      if (frame != "GIDE") {
        // Mesh is opened on some other parent app e.g. GIDE Marketing website so the element will not be visible
        return false
      }
      else {
        // element is on GIDE
        return true
      }
    },
    /**
      * text to speech
      */    
    async speak (transcript) {
      // Create a SpeechSynthesisUtterance
      const utterance = new SpeechSynthesisUtterance(transcript)
      // utterance.voice = this.voices[78] // Choose a specific voice default "Lekha" South Indian Accent / hi-IN
      utterance.voice = this.voices[108] // Choose a specific voice default "RIshi" Indian Accent / en-IN
      // utterance.voice = this.voices[164] // Choose a specific voice default "Google"  / hi-IN
      // Speak the text
      speechSynthesis.speak(utterance)
    }
  },
  watch: {
    /**
     * selectedGroup
     */
    selectedGroup: function () {
      this.pagination_message_id = null;
      this.get_group_details();  
      this.set_participant_as_admin();
    },
    /**
     * getNewMessage
     */
    getNewMessage(message){
      console.log("New Message:- ", message);
      this.add_new_msg(message);
    },
    /**
     * getListenerChatmsgAddResponse
     */
    getListenerChatmsgAddResponse(message){
      //move group at top when new message come from listner
      if(!this.mention_message_show){
        this.add_new_msg(message);
      }
    },
    /**
     * getListenerChatgrpEditResponse
     */
    async getListenerChatgrpEditResponse(group){
      let selectedGroup = await this.selectedGroup;
      if(selectedGroup == group.groupInfo.group_id){
        this.grp = group.groupInfo;
        this.$emit('grp_details', this.grp);
      }
    },
    /**
     * getListenerGroupActionResponse
     */
    getListenerGroupActionResponse(action_data){
      if(action_data.user_id == this.userData.user_id){ 
        //Not need for user who hit action
        return;
      }
      
      if(action_data.role != null && action_data.role !=undefined){
        this.grp.role = action_data.role;
        this.set_participant_as_admin();
        this.$emit('grp_details', this.grp);
      }

      if(action_data.action == 2){//Remove participant
        if(action_data.participant_id === this.userData.user_id){
          //Trigger for removed participant user
          this.err_msg = "You have been removed from the group "+this.data.group_name + " by the group admin";
          this.snackbar = true;
          this.$router.push('/chat');
          return false;
        }
      }
    },
    /**
     * getListenerGroupDeleteResponse
     */
    getListenerGroupDeleteResponse(data){
      if(data.user_id != this.userData.user_id){//Check for logged in user
        this.snackbar = true;
        this.err_msg = "You are no longer group member of "+data.group.group_name;
        this.$router.push('/chat');
      }
    },
    /**
     * getListenerUserEditResponse
     */
    getListenerUserEditResponse(user){
      //check for group type one to one and change group name as participant
      if(this.grp.type == 0){
        if(this.grp.participants && this.grp.participants != null){
          let participants = this.grp.participants.split(',');
          participants.forEach((participant_id)=>{
            if(participant_id === user.user_id){
              this.grp.group_name = user.user_name;
              if(user.image){
                this.grp.group_icon = user.image;
              }
            }
          })
        }
      }
      //Change user name if any user change your info and exist in group
      if(this.data.length > 0){
        this.data.forEach((message, key) =>{
          if(message.sender_id &&  message.sender_id == user.user_id){
              this.data[key].sender_name = user.user_name;
              if(user.image){
                this.data[key].sender_image = user.image; 
              }
              this.data[key].sender_location = user.country_name; 
              this.data[key].sender_designation = user.designation; 
              this.data[key].sender_company = user.company; 
          }
        })
      }
    },
    /**
     * getListenerChatmsgDeleteResponse
     */
    getListenerChatmsgDeleteResponse(message){
      let msgIndex = Object.keys(message);
      let message_index = this.data.findIndex((msg) => {
        return msg.this_message_id == msgIndex;
      });
      if(message_index > '-1'){
        this.data.splice(message_index, 1);
      }
    },
    /**
     * getSnackBar
     */
    getSnackBar:function(snackbar){
      this.err_msg = snackbar.msg;
      this.snackbar = snackbar.show;
    },
    /**
     * currentItem
     */    
    currentItem:function(){
      if(this.currentItem == 0) {
        this.data = [];
        this.pagination_message_id = null;
        this.infiniteId += 1;
      }
    },
    /**
     * selectedTag
     */    
    selectedTag:function () {
      if(this.calledFromTag) {
        if(!this.selectedTag) {
          this.data = [];
        }
      }
    },
   /*
    * searchKeyword
    * 
    */
    searchKeyword: function() {
      if(this.calledFromSearch) {
        this.data = [];
        this.pagination_message_id = null;
        this.infiniteId += 1;
      }
    },
    /**
     * top_to_bottom_arrow
     * When a user scrolls up to an old message an arrow button appears so that the user may scroll down
     * Also, the color of the arrow changes on a new message arriavl
     */
    top_to_bottom_arrow(value){
      if(value){
        this.top_to_bottom_arrow_style['background-color'] = '#e5252c'; //Gray color its default color at our theme
      }
      else{
        this.top_to_bottom_arrow_style['background-color'] = '#ffca28'; //orange color
      }
    }
  },
  directives:{
    plaintext:function(el, binding, vnode){
      let msg = el.textContent;
      var tagStrArr = vnode.context.getUserTags(msg)
      if(tagStrArr){
          msg = vnode.context.replaceUserIdMACRO(msg, tagStrArr);
          el.innerHTML = msg;
      }
    },
    'longclick': longClickInstance,
  }
}
